import { render, staticRenderFns } from "./hpAccordionItem.vue?vue&type=template&id=b99384c2&scoped=true&"
import script from "./hpAccordionItem.vue?vue&type=script&lang=js&"
export * from "./hpAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./hpAccordionItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./hpAccordionItem.vue?vue&type=style&index=1&id=b99384c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99384c2",
  null
  
)

export default component.exports